import React, { useContext } from 'react';
import { Box } from '@match/react-component-library';
import TopNavMenu from '@match/react-top-nav-menu';
import { getABTest } from '@match/app-rules-resolver';
import { SiteDataContext } from 'App';

const TopNav: React.FunctionComponent = () => {
  const siteData = useContext(SiteDataContext);

  return (
    <Box height={56}>
      <TopNavMenu
        activeListItem="/help"
        canPurchaseReplyForFree={siteData.canPurchaseReplyForFree}
        canReactivate={siteData.canReactivate}
        countryCode={siteData.countryCode}
        cultureCode={siteData.cultureCode}
        isCompedUser={siteData.isCompedUser}
        isInABTest={(abTestName) => getABTest(abTestName, siteData.abTests)}
        isLoggedIn={siteData.isLoggedIn}
        isPremiumSub={siteData.isPremiumSub}
        isSubscriber={siteData.isSubscriber}
        primaryPhotoUri={siteData.isLoggedIn ? siteData.primaryPhotoUri : ''}
        siteCode={siteData.siteCode}
        urlCode={siteData.urlCode}
      />
    </Box>
  );
};

export default TopNav;
